import ExtendedPropertyType from 'owa-service/lib/contract/ExtendedPropertyType';
import ExtendedPropertyUri from 'owa-service/lib/contract/ExtendedPropertyUri';
import extendedPropertyUri from 'owa-service/lib/factory/extendedPropertyUri';
import Item from 'owa-service/lib/contract/Item';
import ItemInfoResponseMessage from 'owa-service/lib/contract/ItemInfoResponseMessage';
import itemResponseShape from 'owa-service/lib/factory/itemResponseShape';
import { checkIfResponseSuccess, ClientItem, getItem } from 'owa-mail-store';
import { trace } from 'owa-trace';

const LANGUAGEFOREMAIL_PROPERTYNAME = 'EntityExtraction/ExtractLanguage1.0';
const LANGUAGEFOREMAIL_DISTINGUISHEDPROPERTYSETID = 'Common';
const LANGUAGEFOREMAIL_PROPERTYTYPE = 'String';

const LANGUAGE_KEY = 'Language';
const LOCALE_KEY = 'Locale';

const detectedLanguageExtendedPropertyUri: ExtendedPropertyUri = extendedPropertyUri({
    PropertyName: LANGUAGEFOREMAIL_PROPERTYNAME,
    DistinguishedPropertySetId: LANGUAGEFOREMAIL_DISTINGUISHEDPROPERTYSETID,
    PropertyType: LANGUAGEFOREMAIL_PROPERTYTYPE,
});

export default async function getLocalePropertyForItem(item: ClientItem): Promise<string> {
    // Encrypted items are not supposed to have language stamped.
    // But these (along with all right protected) items are always stamped with 'en-US'.
    // We are ignoring detected language for these items
    if (item.RightsManagementLicenseData) {
        return '';
    }

    // Get the extended property for detected language
    const itemShape = itemResponseShape({
        BaseShape: 'IdOnly',
        AdditionalProperties: [detectedLanguageExtendedPropertyUri],
    });

    const response = await getItem(
        [item.ItemId.Id],
        itemShape,
        null /* shapeName */,
        null /* RequestServerVersion */,
        item.MailboxInfo && item.MailboxInfo.requestOptions
    );

    if (checkIfResponseSuccess(response[0])) {
        const responseItem = response[0] as ItemInfoResponseMessage;
        if (responseItem && responseItem.Items && responseItem.Items[0]) {
            const returnedItem = responseItem.Items[0];
            const extendedProperty = getDetectedLanguagePropertyFromItem(returnedItem);

            if (extendedProperty) {
                // extended property is present, parse and return the locale
                const parsedProperty = JSON.parse(extendedProperty.Value)[0];
                return parsedProperty[LANGUAGE_KEY] != null
                    ? parsedProperty[LANGUAGE_KEY][LOCALE_KEY]
                    : '';
            } else {
                trace.info(
                    'getDetectedLanguageForEmailProperty: No language property found for item.'
                );
            }
        } else {
            trace.info(
                'getDetectedLanguageForEmailProperty: Unable to parse GetItem response properly.'
            );
        }
    }
    return '';
}

function getDetectedLanguagePropertyFromItem(item: Item): ExtendedPropertyType {
    const extendedProperties = item.ExtendedProperty;
    if (extendedProperties) {
        const numProperties = extendedProperties.length;
        for (let i = 0; i < numProperties; i++) {
            const prop = extendedProperties[i];
            if (prop.ExtendedFieldURI.PropertyName === LANGUAGEFOREMAIL_PROPERTYNAME) {
                return prop;
            }
        }
    }
    return null;
}
